/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Validation_Debt_Entries_RequiredInputs */

const en_case_validation_debt_entries_required = /** @type {(inputs: Case_Validation_Debt_Entries_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add at least one debt.`)
};

const pt_br2_case_validation_debt_entries_required = /** @type {(inputs: Case_Validation_Debt_Entries_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione pelo menos um débito.`)
};

/**
* | output |
* | --- |
* | "Add at least one debt." |
*
* @param {Case_Validation_Debt_Entries_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_validation_debt_entries_required = /** @type {((inputs?: Case_Validation_Debt_Entries_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Validation_Debt_Entries_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_validation_debt_entries_required(inputs)
	return pt_br2_case_validation_debt_entries_required(inputs)
});